export enum SortDirectionType {
  ASC = "ASC",
  DESC = "DESC",
}
